<ng-content></ng-content>
<span
	*ngIf="marked"
	[attr.data-cy]="'mark-' + id"
	class="position-absolute c-translate-x-40-invert rounded-circle bg-primary p-1 ms-1"
></span>
